import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';
import { reduxForm, Field, change } from 'redux-form';
import RenderCheckBoxField from '../../../shared/components/form/CheckBox';
import { WEEK_DAYS } from '../../../shared/utils/constants';

const Weekdays = (props) => {
  const { t, dispatch, weekdays, dto, onChangeWorkingDaysInCalendar } = props;
  const [week, setWeek] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const changeWeekdays = (value, index) => {
    const updatedDays = [...week];
    updatedDays[index] = Boolean(value);
    setWeek(updatedDays);
    onChangeWorkingDaysInCalendar(updatedDays);
  };

  useEffect(() => {
    setWeek(weekdays);
    dispatch(change('AcademicCalendarForm', 'weekdays', weekdays));
  }, [weekdays]);

  return (
    <>
      <span className="bold-text">{t('general.insert-school-days')}</span>
      <div className="d-flex flex-wrap mt-3">
        {week.map((day, index) => (
          <div key={uuid()} className="mr-2 mb-2 d-flex">
            <Field
              name={WEEK_DAYS[index]}
              component={RenderCheckBoxField}
              className="colored-click"
              defaultChecked={day}
              disabled={dto.id > 0}
              onChange={({ target }) =>
                target && changeWeekdays(target.checked, index)
              }
            />
            <span className="generic__label">
              {t(`calendar.week-day-long.${WEEK_DAYS[index]}`)}
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

Weekdays.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  weekdays: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.bool),
    PropTypes.string,
  ]).isRequired,
  onChangeWorkingDaysInCalendar: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'AcademicCalendarForm',
})(withTranslation('common')(Weekdays));
